import { StatusCredential } from "libLegacy/api/auth";

export const MESSAGES: Record<
  Exclude<StatusCredential, "VALIDATED">,
  string
> = {
  MISSING:
    "Para ter acesso a essas funcionalidades, é preciso que você preencha as credenciais da sua concessionária.",
  PENDING:
    "Estamos processando os seus dados. Em breve, as suas informações aparecerão aqui.",
  UNSUPPORTED:
    "Colocamos você na nossa lista de espera, e te avisaremos assim que a sua concessionária estiver disponível.",
  INVALIDATED:
    "Houve algum erro nos dados que você preencheu. Preencha novamente e tenha acesso à funcionalidades.",
};
